import { createModel } from '@rematch/core';
import { RecordModel, RecordIDModel } from '@equifinance/shared';
import { RootModel } from '.';

const fields = [
  'accountId',
  'personId',
  'type',
  'note',
  'timestamp',
] as const;
export type Note = RecordIDModel<typeof fields[number]>;

const notesModel = createModel<RootModel>()({
  ...RecordModel<Note>(fields),
});

export default notesModel;
